<template>
   <div ref="popover" id="popover" v-click-outside="closePopover" @keydown.esc="closePopover">

      <div v-show="isAddNote">
         <textarea ref="noteArea" type="text" class="form-control" v-model.trim="note"
            placeholder="Note (optional)" style="height: 100px"></textarea>
      </div>
         
      <!-- LOST LEAD REASON -->
      <div v-show="isLeadStatusLost">
         <LostLeadForm ref="lostLeadFormRef" :isLeadStatusLost="isLeadStatusLost"/>
      </div>
      <!-- END --LOST LEAD REASON -->

      <div class="mt-3 text-end" v-show="isAddNote || isLeadStatusLost">
         <button type="button" class="btn btn-sm" @click="cancelChange($event)"> Cancel </button>
         <button type="button" class="btn btn-sm btn-success" @click="saveNote($event)" :disabled="disableFormButton()"> Save </button>
      </div>

      <!-- PROMPT IF NO PROPOSAL FILE UPLOADED -->
      <div v-show="isProposalSent">

         <div>
            <p>Must have at least one proposal file uploaded.</p>
            <p>Click <i>Upload Proposal</i> button to continue.</p>
         </div>

         <div class="mt-3 text-end">
            <button type="button" class="btn btn-sm" @click="cancelChange($event)"> Cancel </button>
            <button type="button" class="btn btn-sm btn-success" @click="uploadProposal($event)" :disabled="disableFormButton()"> Upload Proposal </button>
         </div>
         
      </div>
      <!-- END -- PROMPT IF NO PROPOSAL FILE UPLOADED -->
      
      
   </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { Popover } from 'bootstrap';
import LostLeadForm from '@/components/Leads/LostLeadForm.vue'

export default ({

   components: {
      LostLeadForm
   },

   setup () {
      return { v$: useVuelidate() }
   },

   emits: ['cancelChange', 'onUploadProposal'],
   
   data(){
      return {
         leadId: '',
         leadStatusId: '',
         note: '',
         isAddNote: true,
         isStatusUpdate: false,
         isLeadStatusLost: false,
         isProposalSent: false,
      }
      
   },

   methods: {

      resetData() {
         this.leadId = ''
         this.leadStatusId = ''
         this.note = ''
         this.isAddNote = true
         this.isStatusUpdate = false
         this.isLeadStatusLost = false
         this.isProposalSent = false
      },

      showPopover(e, leadId, leadStatusId, type) {
         
         this.resetData()

         let header = ''
         
         if (type == "lostLead"){
            header = "Loss Reason"
            this.isAddNote = false
            this.isLeadStatusLost = true
            this.isProposalSent = false
         } else if (type == "proposalSent") {
            header = "Upload Proposal"
            this.isAddNote = false
            this.isLeadStatusLost = false
            this.isProposalSent = true
         } else {
            header = "Add Note"
            this.isAddNote = true
            this.isLeadStatusLost = false
            this.isProposalSent = false

            if (type == "statusUpdate") {
               this.isStatusUpdate = true
            }
         }

         let opts = {
            placement: "bottom",
            sanitize: false,
            title: header,
            html: true,
            content: this.$refs.popover
         }
         
         //close all open popovers first
         this.closePopover(e)
         
         this.leadStatusId = leadStatusId
         this.leadId = leadId

         if (this.isStatusUpdate) {
            this.updateLeadStatus()
         }

         // if in case user double clicked the same element, hide the popover first
         if (Popover.getInstance(e) != null){
            Popover.getInstance(e).dispose()
         }

         setTimeout(()=>{
            Popover.getOrCreateInstance(e, opts).show()
         },100);
         // Popover.getOrCreateInstance(e, opts).show()

         if (this.isAddNote){
            this.$refs.noteArea.focus()
         }

         if(this.isLeadStatusLost){
            this.$refs.lostLeadFormRef.resetForm()
         }

      },

      closePopover(e){
         
         var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
         popoverTriggerList.map((el) => {
            if (el != e.target && Popover.getInstance(el) != null){
               Popover.getInstance(el).dispose()
               
               // refresh data or change back to current status if in case user 
               // clicks the same or another dropdown before saving changes for lost lead and proposal sent
               if(this.isLeadStatusLost || this.isProposalSent || this.isStatusUpdate) {
                  if (e.target === 'undefined' || (e.target != null && Popover.getInstance(el) == null)){
                     this.$emit('cancelChange')
                  }

               }
            }
         })

         this.note = ''
      },

      async saveNote(e) {

         if (this.isLeadStatusLost) {
            this.updateLeadStatus(e)
         } else {

            if (this.note != '') {
               let leadNote = {
                  note_type : 'update_note',
                  note_details : this.note,
                  lead_id : this.leadId,
               }

               await this.$axios.post("/leads/"+this.leadId+"/notes",leadNote)
               .then((response) => {
                  if(response.data.success){
                     this.$toast.success(response.data.message)

                     this.closePopover(e);

                  } else {
                     this.$toast.error(response.data.message)
                  }
               })
               .catch((error) => {
                  this.$toast.error(error.response.data.message)
               })

            }
         }

      },

      uploadProposal(e) {
         if (this.isProposalSent) {
            this.$emit('onUploadProposal', {action: 'proposal', id: this.leadId})
            this.closePopover(e)
         }
      },

      //if lost lead
      async updateLeadStatus(e) {
        
         let lead = {
            lead_status_id : this.leadStatusId,      
         }

         if (this.isLeadStatusLost) {

            // save reason for the dropdown or the specified reason
            let noteDetails = this.$refs.lostLeadFormRef.lostLeadReasonValue()
            
            lead.lead_notes = []
            lead.lead_notes.push({
               note_details : noteDetails
             })
         }
         
         await this.$axios.put("/leads/"+this.leadId+"/status", lead)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               if (this.isLeadStatusLost) {
                  this.closePopover(e);
               }
               
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

         this.$refs.lostLeadFormRef.resetForm()
      },

      cancelChange(e) {
         if(this.isLeadStatusLost){
            this.$refs.lostLeadFormRef.resetForm()
         }
         
         this.closePopover(e)

         // setTimeout(()=>{
         //    this.$emit('cancelChange')
         // },500);
         this.$emit('cancelChange')
      },

      disableFormButton(){

         if (this.v$.$invalid || this.v$.$error) {
            return true
         }

         return false
      },

   },
})
</script>
